<script>
import { hasAdminRole } from '@/api/Utilities.js'
import { getMyUserId } from '@/api/FirebaseUserWrapper.js'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
const analytics = getAnalytics(firebaseApp)
require('../../css/style.css')
export default {
  components: {},
  data () {
    return {
      userId: '',
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    this.userId = await getMyUserId()
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'about/About')
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.about {
  margin: auto;
  max-width: 1180px;
  padding: 1.0rem;
}
.registor {
  padding: 50px;
}
.feature {
  background-color: #f0f8ff;
  width: auto;
  padding: 1.5rem
}
.block {
  background-color: #ffffff;
  width: auto;
  padding: 1.5rem
}
.subfooter {
  background-color: #191970;
  color: #fff;
  width: auto;
  padding: 3rem 1.5rem 6rem
}
.add-marginleft{
  margin-left: 2.0rem;
}
.is-rounded {
  border: 1px solid #999999;
  border-radius: 10px;
}
.is-60 {
  width: 60%;
}
.is-80 {
  width: 80%;
}
.arign-center {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
<template>
  <div class="about">
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle">{{title}}</p>
        <p class="title">何をしていたか ひと目でわかる</p>
        <p class='text'>〜毎日のチームのタスクや状況の確認を{{title}}で〜</p>
        <br>
        <div class="buttons has-addons is-centered">
          <router-link  to="login">
            <span class="button is-link is-inverted is-outlined is-focused has-text-weight-bold">
              <strong>無料サインアップ</strong>
            </span>
          </router-link>
        </div>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/about.png">
      </div>
    </div>
    <div class="feature has-text-left">
      <p class="subtitle has-text-weight-bold">{{title}}でできること</p>
      <p class="text has-text-weight-bold">チームワークのために</p>
      <p class="text">{{title}}はコミュニケーションができるマインドツリーです。マインドマップの形式でタスクを貼ったり、チャットもできるので「何をしているか」がわかり、サクッと全体を把握をすることができます。</p>
      <p class="text">個人がアイデア検討やタスク管理をするにも場合にもツリー形式で分岐を検討できるため最適です。</p>
      <br>
      <span class="text has-text-weight-bold is-size-6">こんな課題に対応<br></span>
      <div class="text has-text-left">
        <div class="arign-center">
          <p class="text has-text-weight-bold">
            <a href="#lp1"><i class="fa-regular fa-check-square"></i>&nbsp;リモートワークで仲間が何をしているかわからない...</a><br>
            <a href="#lp2"><i class="fa-regular fa-check-square"></i>&nbsp;グループチャットは話題がすぐ流れて話題を追えない...</a><br>
            <a href="#lp3"><i class="fa-regular fa-check-square"></i>&nbsp;プロジェクトの全体像が見えない...</a><br>
          </p>
        </div>
      </div>
      <br>
      <div class="columns is-multiline is-mobile">
        <div class="column is-4-tablet is-12-mobile">
          <div class="block">
            <div class="text has-text-centered has-text-weight-bold is-size-6">
              チーム
            </div>
            チームを作って内部で情報の共有・チャットを行うことができます。
          </div>
        </div>
        <div class="column is-4-tablet is-12-mobile">
          <div class="block">
            <div class="text has-text-centered has-text-weight-bold is-size-6">
              ツリー
            </div>
            ツリーを作って２次元チャット形式で進捗管理することができます。
          </div>
        </div>
        <div class="column is-4-tablet is-12-mobile">
          <div class="block">
            <div class="text has-text-centered has-text-weight-bold is-size-6">
              ふせん
            </div>
            自分でふせんを重ねたり相手のふせんにチャットすることができます。
          </div>
        </div>
      </div>
    </div>
    <hr id="lp1">
    <br>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">何しているかひと目でわかる</p>
        <p class='text'>
          リモートワークで同僚が「いま何しているか」わからなくて困っていませんか？<br>
          情報共有のためだけに通話するのは相手の時間も奪ってしまって心配です。<br>
          {{title}}では、ふせんでお互いの「いまやっていること」を共有することでチーム内で誰が何の作業しているがひと目でわかります。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded is-80" src="./img/lp1.png">
      </div>
    </div>
    <hr id="lp2">
    <br>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">あとからでも話題に参加できる</p>
        <p class='text'>
          チャットがすぐに流れてしまって質問や議論の機会を失ってしまって困っていませんか？<br>
          ふせんで全体が見わたせるので、どの話題からでもチャットを開始して質問できます。<br>
          意見が必要な場合には同僚へメンションすることも可能です。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded is-60" src="./img/lp2.png">
      </div>
    </div>
    <hr id="lp3">
    <br>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">何が起きているかわかる</p>
        <p class='text'>
          プロジェクトで開発・企画など各アイテムがどれくらい進んでるかわからないことありませんか？<br>
          各アイテムの進んでいる状況がひと目でわかります。<br>
          タスクの全体像をみえる化することでプロジェクトの抜け漏れを防ぐことができます。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded is-80" src="./img/lp3.png">
      </div>
    </div>
    <hr>
    <div class="buttons has-addons is-centered">
      <router-link  to="/about/team">
        <span class="button is-rounded is-link is-inverted is-outlined is-focused has-text-weight-bold">
          <strong>詳しく機能を知る</strong>
        </span>
      </router-link>
    </div>
    <br>
    <div class="text has-text-left">
      <span class="text has-text-weight-bold is-size-5">{{title}}の特徴<br></span>
      <p>
        slackやteamsのチャットでは、自分が目的をもって相手に話しかける必要があります。<br>
        {{title}}のふせんUIでは、ツイートように自分でふせんを重ねたり、それを見て相手に話しかけたり<br>
        多様な目的を生むことができ、仲間の状況を把握したりアイデアや議論の幅を深めていくことができます。<br>
      </p>
    </div>
    <br>
    <div class="registor">
      <p class="text has-text-weight-bold is-size-4">{{title}}をはじめよう</p>
      <br>
      <div class="buttons has-addons is-centered">
        <router-link  to="login">
          <span class="button is-link is-inverted is-outlined is-focused has-text-weight-bold">
            <strong>新規登録</strong>
          </span>
        </router-link>
      </div>
    </div>
    <br>
    <div class="subfooter">
      <div class="content has-text-centered is-size-7">
        <div class="columns is-multiline is-mobile">
          <div class="column is-half">
            <router-link to="teams" class="has-text-white">
              <p>開発チーム</p>
            </router-link>
          </div>
          <div class="column">
            <router-link to="terms" class="has-text-white">
              <p>利用規約</p>
            </router-link>
          </div>
        </div>
        <div class="columns is-multiline is-mobile">
          <div class="column is-half">
            <router-link to="privacy" class="has-text-white">
              <p>プライバシー</p>
            </router-link>
          </div>
          <div class="column">
            <router-link to="contact" class="has-text-white">
              <p>お問合せ</p>
            </router-link>
          </div>
        </div>
        <p>@socialup</p>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/about/About.vue